import { useEffect } from 'react';

import TagManager from '@sooro-io/react-gtm-module';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import { setGtmInstantiated } from '@/services/gtm/gtmSlice';

export function GtmSetup() {
  const { isDependencyEnabled } = usePaymentsConfig();
  const dispatch = useAppDispatch();
  const gtmState = useAppSelector(state => state.gtm);

  // Reset the GTM flag directly when this top-level component mounts;
  // as it sits away from of our form step component (so won't remount).
  useEffect(() => {
    dispatch(setGtmInstantiated(false));
  }, [dispatch]);

  // Checks that GTM is enabled in serverless-payments-bootstrap first, as well
  // as checking we've got cart data AND have yet to initialise GTM:
  useEffect(() => {
    if (Boolean(isDependencyEnabled('gtm')) && !gtmState.gtmInstantiated) {
      TagManager.initialize({
        gtmId: 'GTM-TDZ4454'
      });

      // Update our global state flag accordingly to prevent re-initialising:
      dispatch(setGtmInstantiated(true));
    }
  }, [isDependencyEnabled, gtmState, dispatch]);
}
